import { render, staticRenderFns } from "./new_employees.vue?vue&type=template&id=a4fb278e"
import script from "./new_employees.vue?vue&type=script&lang=js"
export * from "./new_employees.vue?vue&type=script&lang=js"
import style0 from "./new_employees.vue?vue&type=style&index=0&id=a4fb278e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports